<template>
    <div class="position-box">
        <div class="head">
            <div class="back-box" @click="goBack"><img class="icon" src="@/assets/icon_back.png" alt="back"></div>
        </div>
        <div class="bg">
            <ul class="list-box">
                <li class="list">
                    <div class="title">{{$t('sztxmm.t8')}}</div>
                </li>
                <li class="list list-code">
                    <input class="input" type="password" v-model="tpassword" :placeholder="$t('sztxmm.t3')" autocomplete="off">
                </li>
                <li class="list list-code">
                    <input class="input" type="password" v-model="tpassword_again" :placeholder="$t('sztxmm.t3')" autocomplete="off">
                </li>
                <button class="btn" type="button" @click="sure">{{this.$t('sztxmm.t6')}}</button>
            </ul>
        </div>
    </div>
</template>
<script>
export default {
    name: 'setWithdrawPwd',
    data () {
        return {
          token: '',
          password: '',
          tpassword: '',
          tpassword_again: '',
          count: 1
        }
    },
    mounted(){
      this.token = localStorage.getItem('token');
      $("input").keyup(function(){	//去掉空格
        $(this).val($(this).val().replace(/[, ]/g,''));
      });
    },
    methods: {
      goBack(){
           this.$router.push('/safety')
       },
      sure(){
           var reg = /^(?:\d+|[a-zA-Z]+|[!@#$%^&*]+){6,12}$/;
            var data = {
                tpassword : this.tpassword,
                tpassword_again : this.tpassword_again
            }
            if(data.tpassword == '' || data.tpassword == null){
                this.$toast.center(this.$t('sztxmm.t3'));
                return false;
            }else if(!reg.test(data.tpassword)){
                this.$toast.center(this.$t('sztxmm.t3'));
                return false;
            }
            if(data.tpassword != data.tpassword_again){
                this.$toast.center(this.$t('sztxmm.t3'));
                return false;
            }
            this.$ajax.post('/web/updateTpassword',data).then((res) => {
                let resData = res.data;
                if(resData.code == 0 || resData.code == 4 || resData.code == 7){
                    this.$toast.center(this.$t('status.statusText')[2]);
                    setTimeout(() => {
                        this.$router.push('/safety')
                    }, 1000)
                }else{
                    this.$toast.center(resData.message);
                    return;
                }
            }).catch(function(err){
                console.log(err)
            })
       }
    },
     beforeDestroy(){
      clearTimeout(this.timer);
      this.timer = null;
    }
}
</script>
<style scoped>
    input::-webkit-input-placeholder{
        color: #d2d2d2;
        font-size: .42rem;
    }
    .position-box{
        position: absolute;
        left: 0;
        top: 0;
        bottom: 0;
        width: 100%;
        height: auto;
        color: #cecece;
        font-size: .36rem;
        background: url('../assets/element-background.png') no-repeat center center;
        background-size: cover;
        overflow: hidden;
    }
    .head{
        position: relative;
        height: 1.2rem;
        font-size: .36rem;
        line-height: 1.2rem;
        /* background: #0e1530; */
        text-align: center;
    }
    .head .icon{
        position: absolute;
        left: .3rem;
        top: .3rem;
        width: .32rem;
        height: .6rem;
    }
    .bg{
        position: absolute;
        width: 100%;
        height: calc(100% - .8rem);
        /* background: #0e1530; */
    }
    .list-box{
        padding: 0 .3rem;
        color: #ababab;
        /* background: #0e1530; */
    }
    .list-box .list.list-code{
      border-bottom: 1px solid #858585;
    }
    .list-box .list .title{
      color: #fff;
      font-size: .72rem;
    }
    .list-box .list-text{
        font-size: .42rem;
    }
    .list-box .input-box{
        display: flex;
        justify-content: space-between;
        align-items: center;
        border-radius: 4px;
    }
    .list-box .list{
      padding: .48rem 0 .48rem .24rem;
    }
    .list-box .list .input{
        width: 100%;
        height: .8rem;
        color: #d0d0d0;
        font-size: .48rem;
        background: transparent;
    }
    .list-box .input-box .input{
        flex: 1;
        border: none;
    }
    .list-box .input-box .code{
        padding: .8rem .26rem 0 0;
        color: #fff;
        font-size: .48rem;
    }
    .tips{
        margin-top: .2rem;
        color: #2CAADE;
        font-size: .42rem;
        text-align: right;
    }
    .btn {
        width: 100%;
        height: 1.2rem;
        margin-top: 2.6rem;
        color: #fff;
        font-size: .48rem;
        line-height: 1.2rem;
        background: linear-gradient(left, rgba(44, 170, 222, 0.5), rgba(93, 205, 233, 0.5));
        border-radius: .2rem;
    }
</style>



// WEBPACK FOOTER //
// src/pages/setWithdrawPwd.vue